var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{staticClass:"full-width q-mb-sm",attrs:{"icon-right":"keyboard_arrow_right","disable":_vm.isVoid || _vm.isMulti,"label":_vm.label_},on:{"click":_vm.openTableDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }